import { excelSerialToJsDate, isIsoDate, javascriptDateToMMDDYYYY, javascriptDateToYYYYMMDD, jsDateToExcelSerial } from '../helpers/date-helpers';
import { isSupportedDataType, isValidDateInput, isValidExchangeTickerSymbol } from '../helpers/args-validators';
import { FunctionCallCache } from '../helpers/functionCallCache';
import { FunctionLocationTracker } from '../helpers/functionLocationTracker';
import { KeyBuilder } from '../helpers/keyBuilder';
const SUPPORTED_DATETYPES = ['Traded_Volume_Shares', 'Adjusted_Traded_Volume_Shares', 'Trading_Currency', 'Fund_Name', 'Trading_Days'];
function validateArgs(symbol, dataType, date, end_date) {
    if (!isValidExchangeTickerSymbol(symbol)) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid symbol (expected format: EXCHANGE:TICKER)');
    }
    if (!isSupportedDataType(SUPPORTED_DATETYPES, dataType)) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid data type');
    }
    // some data types do not require a date
    if (isSupportedDataType(['Trading_Currency', 'Fund_Name'], dataType)) {
        return true;
    }
    if (!isValidDateInput(String(date))) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid date');
    }
    // some data types do not require an end date
    if (isSupportedDataType(['Traded_Volume_Shares', 'Adjusted_Traded_Volume_Shares'], dataType)) {
        return true;
    }
    if (!isValidDateInput(String(end_date))) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid end date');
    }
    return true;
}
let delegate = () => {
    throw new CustomFunctions.Error(CustomFunctions.ErrorCode.notAvailable, 'Initializing… press F9 to recalc.');
};
export function setOtherMarketDataDelegate(fn) {
    delegate = fn;
}
export function otherMarketDataWrapper(symbol, dataType, date, endDate, invocation) {
    return delegate(symbol, dataType, date, endDate, invocation);
}
export function otherMarketDataImpl(symbol, dataType, date, endDate, invocation) {
    validateArgs(symbol, dataType, date, endDate);
    const javascriptDate = String(date).includes('/') ? new Date(date) : excelSerialToJsDate(Number(date));
    const queryDate = javascriptDateToYYYYMMDD(javascriptDate);
    const javascriptEndDate = String(endDate).includes('/') ? new Date(endDate) : excelSerialToJsDate(Number(endDate));
    const queryEndDate = javascriptDateToYYYYMMDD(javascriptEndDate);
    const cache = FunctionCallCache.getInstance();
    const tracker = FunctionLocationTracker.getInstance();
    const args = { symbol, dataType, date: queryDate, endDate: queryEndDate };
    const key = KeyBuilder.build('other_market_data', args);
    cache.registerByKey(key, { functionName: 'other_market_data', params: args });
    if (invocation?.address) {
        // the key contains the function name and args
        if (endDate == null || endDate === '') {
            tracker.registerCell(key, invocation.address, `=ALPHA.OTHER_MARKET_DATA("${symbol}", "${dataType}", "${javascriptDateToMMDDYYYY(javascriptDate)}")`);
        }
        else {
            tracker.registerCell(key, invocation.address, `=ALPHA.OTHER_MARKET_DATA("${symbol}", "${dataType}", "${javascriptDateToMMDDYYYY(javascriptDate)}", "${javascriptDateToMMDDYYYY(javascriptEndDate)}")`);
        }
        cache.setAutoRefresh(key);
    }
    const value = cache.getValueForExcelByKey(key);
    if (Array.isArray(value)) {
        return value.map((item) => {
            if (isIsoDate(item)) {
                return [jsDateToExcelSerial(new Date(item))];
            }
            return [item];
        });
    }
    return [[value]];
}
//# sourceMappingURL=otherMarketData.js.map